
const dafaultState = {
    certInfoSignature: null,
    certInfoKeyAgreement: null
}

export default function (state=dafaultState, { type, payload }) {
	switch(type) {
		case "CERTIFICATE_INFO": {
			return {
				...state,
				certInfoSignature: payload
			}
		}

		case "CLEAR_CERTIFICATE_INFO": {
			return {
				...state,
				certInfoSignature: payload
			}
		}

		case "CERTIFICATE_INFO_KEY_AGREEMENT": {
			return {
				...state,
				certInfoKeyAgreement: payload
			}
		}

		case "CLEAR_CERTIFICATE_INFO_KEY_AGREEMENT": {
			return {
			    ...state,
				certInfoKeyAgreement: payload
			}
		}

		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/certificateInfo.js